export default "__VITE_ASSET__gQKt8Khp__"